import useMediaQuery from '@polestar/component-warehouse-react/hooks/useMediaQuery';
import useOnValuesChange from '@polestar/component-warehouse-react/hooks/useOnValuesChange';
import DeviceTypes from '@polestar/component-warehouse-react/tokens/device-types/DeviceTypes';
import { useMotionValue } from 'framer-motion';
import { useCallback, useEffect, useRef, useState } from 'react';
/**
 * Use this whenever breakpoints change and still trigger animations because transition is needed for interaction-animations but no transitions are needed when breakpoints change and transition/translate properties swap then.
 * @param id - is used to identify during debugging
 * @param delay - the delay when to reset animation duration back to its original value
 */
const useBreakpointChanged = (id = `#${Math.round(Math.random() * 1000)}`, delay = 500) => {
    const { name } = useMediaQuery();
    const [breakpointChanged, setBreakpointChanged] = useState(false);
    const timeout = useRef(null);
    const currentWidth = useMotionValue(0);
    const currentBreakpoint = useMotionValue(DeviceTypes.mobile);
    useEffect(() => {
        currentBreakpoint.set(name);
        setBreakpointChanged(true);
    }, [name, currentBreakpoint, id]);
    const updateWidth = useCallback(() => {
        currentWidth.set(window.innerWidth);
    }, [currentWidth]);
    useEffect(() => {
        setBreakpointChanged(true);
        updateWidth();
        window.addEventListener('resize', updateWidth);
        return () => {
            window.removeEventListener('resize', updateWidth);
        };
    }, [updateWidth, id]);
    // trigger validation by a breakpoint change or a resize event
    const handleValueChange = (
    // eslint-disable-next-line
    latestBreakpoint, 
    // eslint-disable-next-line
    latestWidth) => {
        const updateState = () => {
            setBreakpointChanged(false);
        };
        if (!!timeout.current) {
            clearTimeout(timeout.current);
        }
        if (delay > 0) {
            timeout.current = setTimeout(updateState, delay);
        }
        else {
            updateState();
        }
    };
    useOnValuesChange([currentBreakpoint, currentWidth], handleValueChange);
    return breakpointChanged;
};
export default useBreakpointChanged;
